export default "__VITE_ASSET__CGUehHzI__"